import * as tslib_1 from "tslib";
import { Data } from './services/data';
import { Messenger } from './services/messenger';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { readFile } from './services/util';
var ImportComponent = /** @class */ (function () {
    function ImportComponent(data, msg, router, location) {
        this.data = data;
        this.msg = msg;
        this.router = router;
        this.location = location;
    }
    ImportComponent.prototype.fileSelected = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var file, json, data, mapped, res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        file = this.importFile.nativeElement.files[0];
                        return [4 /*yield*/, readFile(file)];
                    case 1:
                        json = _a.sent();
                        try {
                            data = JSON.parse(json);
                        }
                        catch (e) {
                            console.error('error parsing json file', e);
                            this.msg.send('failed to import file, unable to parse json', true);
                            return [2 /*return*/];
                        }
                        mapped = {
                            mealHistory: data.mealHistory.map(this.sanitizeId),
                            bodyHistory: data.bodyHistory.map(this.sanitizeId),
                            weightSetHistory: data.weightSetHistory.map(this.sanitizeId)
                        };
                        return [4 /*yield*/, this.data.importArchive(mapped)];
                    case 2:
                        res = _a.sent();
                        this.msg.send("Import complete, added " + res.meals + " meals, " + res.items + " meal items and " + res.body + " body compositions", false);
                        this.location.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    ImportComponent.prototype.sanitizeId = function (obj) {
        if (typeof obj.id !== 'string') {
            delete obj.id;
        }
        return obj;
    };
    return ImportComponent;
}());
export { ImportComponent };
